export default __webpack_public_path__ + "static/media/box.0d141b58.svg";